import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AccountFacade } from '@mode/accounts/contract';
import { DatasourceFacade, WorkspaceCollectionFacade } from '@mode/accounts/domain';
import { map } from 'rxjs/operators';

import { NavMenuService } from '../nav-menu.service';
import { ThoughtspotIntegrationService } from '@mode/shared/util-thoughtspot-integrated';

@Component({
  selector: 'mode-nav-menu-container',
  templateUrl: './nav-menu-container.component.html',
  styleUrls: ['./nav-menu-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavMenuContainerComponent implements OnChanges {
  @Input() inline = false;
  @Input() target?: string;

  navOpen$ = this._navMenuService.navState();
  currentOrg$ = this._accountFacade.currentOrg$;
  currentUser$ = this._accountFacade.user$;
  datasources$ = this._datasourceFacade.datasources$;
  datasourcesLoading$ = this._datasourceFacade.isDatasourcesLoading$;
  collections$ = this._workspaceCollectionFacade.workspaceCollections$;
  collectionsLoading$ = this._workspaceCollectionFacade.isLoading$;
  personalCollectionToken$ = this._workspaceCollectionFacade.workspaceCollections$.pipe(
    map((collections) => collections.find((collection) => collection.isPrivate)?.token ?? '')
  );
  isAnalystStudio$ = this._thoughtspotIntegrationService.currOrgIntegrated$;

  constructor(
    private _navMenuService: NavMenuService,
    private _accountFacade: AccountFacade,
    private _datasourceFacade: DatasourceFacade,
    private _workspaceCollectionFacade: WorkspaceCollectionFacade,
    private _thoughtspotIntegrationService: ThoughtspotIntegrationService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['inline']?.currentValue) {
      this._navMenuService.loadData();
    }
  }

  closeNavMenu(): void {
    this._navMenuService.close();
  }
}
